import { createSelector } from "reselect";
import {
  getRouteDetail,
  getRouteStops,
  isRouteStatusInBuild,
} from "../../route";
import * as routeDetailModel from "../../../../models/routeDetail";

export const getStopFilters = (state) => state.ui.routeDetail.stopFilters;

export const getSelectedStops = createSelector(
  getRouteStops,
  getStopFilters,
  routeDetailModel.getSelectedStops
);

export const getUniqueRoutesFromSelectedStops = createSelector(
  getSelectedStops,
  routeDetailModel.getUniqueRoutesFromSelectedStops
);

export const getPreparedStops = createSelector(
  getRouteDetail,
  getStopFilters,
  routeDetailModel.getPreparedStops
);

export const getSelectedPreparedStops = createSelector(
  getPreparedStops,
  routeDetailModel.getSelectedPreparedStops
);

export const getFilteredStops = createSelector(
  getStopFilters,
  getPreparedStops,
  getSelectedPreparedStops,
  routeDetailModel.getFilteredStops
);

export const getLeadStop = createSelector(
  getSelectedStops,
  routeDetailModel.getLeadStop
);

export const getAvailableMergeSplitStops = createSelector(
  getLeadStop,
  getRouteStops,
  routeDetailModel.getAvailableMergeSplitStops
);

export const getSelectedStopRequests = createSelector(
  getSelectedPreparedStops,
  (stops) => stops[0]?.requests || []
);

export const isKingColumnDisabled = createSelector(
  getSelectedStopRequests,
  isRouteStatusInBuild,
  (stopRequests, isRouteInBuild) => stopRequests.length || isRouteInBuild
);
